export default "__VITE_ASSET__DO5N2IsE__"